import { Details, SummaryList } from 'nhsuk-react-components';
import { getAllRulesSortedByPriority, IterationRuleWithAndClauses } from 'utils/ruleUtils.ts';
import RuleAttribute from './RuleAttributes.tsx';
import './RulesTable.scss';

interface TeamDefaultRulesProps {
  rules: IterationRuleWithAndClauses[];
}
function TeamDefaultRules({ rules }: TeamDefaultRulesProps) {
  if (!rules.length) {
    return null;
  }

  return (
    <>
      {getAllRulesSortedByPriority(rules).map((rule, idx) => (
        <SummaryList.Row key={rule.ID} className="summary-table-row">
          <SummaryList.Value className="default-rules-value">
            <div className="default-rules-container">
              <Details.Text>
                <div className="rule-details">
                  <div className="rule-priority nhsuk-u-secondary-text-colour default-rule-priority">
                    {idx + 1}
                  </div>
                  <div className="default-rule-content nhsuk-u-secondary-text-colour">
                    <strong>
                      <div>
                        {rule.Name}
                      </div>
                    </strong>
                    {rule.Description && (
                      <div className="default-rule-description">{rule.Description}</div>
                    )}
                    {rule.AndClauses?.map((andClause) => (
                      <div key={`${andClause.Name}-${andClause.AndNumber}`}>
                        <div className="nhsuk-u-margin-top-3">
                          <strong>AND</strong>
                        </div>
                        <RuleAttribute
                          rule={andClause}
                          isAndClause
                          isDefaultRule
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </Details.Text>
            </div>
          </SummaryList.Value>
          <SummaryList.Action className="default-rule-actions" />
        </SummaryList.Row>
      ))}
    </>
  );
}

export default TeamDefaultRules;
